<template>
  <form
    class="investment-questionnaire-form-wrapper"
    @submit.prevent="sendQuestionnaireForm"
    ref="form"
  >
    <div class="card mb-4">
      <div class="card-body p-4 p-md-5">
        <b-form-group>
          <h5 class="text-highlighted">{{ $t("iq_investment_management") }}</h5>
          <b-form-radio-group v-model="contractType" required>
            <b-form-radio :value="2" class="my-2">
              <span>{{ $t("iq_selfmanaging_contract") }}</span>
            </b-form-radio>
            <br />
            <b-form-radio :value="1">
              <span>{{ $t("iq_managed_by_experts_contract") }}</span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>
    <div class="card" :class="questionnaireType ? 'mb-4' : 'mb-1'">
      <div class="card-body p-4 p-md-5">
        <b-form-group>
          <h5 class="text-highlighted">{{ $t("iq_investment_type") }}</h5>
          <b-form-radio-group v-model="questionnaireType" required>
            <b-form-radio :value="1" class="mt-2">
              <span>{{ $t("iq_investment_type_single_payment") }}</span>
            </b-form-radio>
            <br />
            <b-form-radio :value="1" class="mt-2">
              <span>{{ $t("iq_investment_type_continuous_payment") }}</span>
            </b-form-radio>
            <b-form-radio :value="1" class="mt-2">
              <span>{{
                $t("iq_investment_type_single_and_continuous_payment")
              }}</span>
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
      </div>
    </div>
    <div v-for="(step, i) in model" :key="i" v-if="questionnaireType">
      <h2 class="text-md-left text-center text-highlighted">
        {{ $t(step.heading) }}
      </h2>
      <div class="card" :class="i === model.length - 1 ? 'mb-1' : 'mb-4'">
        <div class="card-body p-4 p-md-5">
          <div class="row mb-3">
            <div
              class="col-12 mt-3"
              :class="question.col ? question.col : 'col-md-6'"
              v-for="(question, j) in step.questions"
              :key="j"
            >
              <b-form-group>
                <label>{{ j + 1 }}. {{ $t(question.text) }}</label>
                <div v-if="question.multiple">
                  <b-form-checkbox-group
                    v-model="question.value"
                    :options="translateOptions(question.options)"
                    :name="'q' + question.id"
                    text-field="value.text"
                    @input="showInput(question)"
                    stacked
                    :required="question.value.length === 0"
                  ></b-form-checkbox-group>
                </div>
                <div v-else>
                  <b-form-radio-group
                    v-model="question.value"
                    :options="translateOptions(question.options)"
                    :name="'q' + question.id"
                    text-field="value.text"
                    @input="showInput(question)"
                    stacked
                    required
                  ></b-form-radio-group>
                </div>
                <div v-if="question.input && !question.input.hidden">
                  <label class="mt-2 mr-2"
                    >{{ $t(question.input.label) }}:</label
                  ><input
                    :type="question.input.type"
                    v-model="question.input.value"
                    :placeholder="$t(question.input.placeholder)"
                    :required="question.input.required"
                  />
                </div>
              </b-form-group>
            </div>
          </div>
        </div>
      </div>
    </div>
    <input ref="submit" type="submit" />
  </form>
</template>

<script>
import questionnaireQuestions from "./InvestmentQuestionnaireQuestions";
import questionnaireShortQuestions from "./InvestmentQuestionnaireShortQuestions";
import { BFormGroup, BFormRadioGroup } from "bootstrap-vue";

export default {
  name: "InvestmentQuestionnaireForm",
  components: { BFormGroup, BFormRadioGroup },
  mounted() {
    this.$store.dispatch("onboarding/getPersonalInfo").then(() => {
      this.contractType = this.$store.state.onboarding.personalInfo[
        "contract_type_id"
      ];
      this.questionnaireType =
        this.$store.state.onboarding.questionnaireType === "short"
          ? 2
          : this.$store.state.onboarding.questionnaireType === "long"
          ? 1
          : "";

      this.$store.dispatch("onboarding/getInvestmentQuestionnaire").then(() => {
        this.setModel();
      });
    });
  },
  computed: {
    questionnaire() {
      return this.$store.state.onboarding.investmentQuestionnaire;
    }
  },
  data() {
    return {
      questionnaireType: "",
      questionnaireTypeId: "",
      contractType: "",
      points: 0,
      input: false,
      model: {}
    };
  },
  watch: {
    questionnaireType() {
      this.questionnaireTypeId = this.questionnaireType;
      this.model =
        this.questionnaireType === 2
          ? questionnaireShortQuestions
          : questionnaireQuestions;
      this.canContinue(
        this.questionnaireType !== "" && this.contractType !== ""
      );
    },
    contractType() {
      this.canContinue(
        this.questionnaireType !== "" && this.contractType !== ""
      );
    }
  },
  methods: {
    canContinue(bool) {
      this.$parent.$emit("can-continue", { value: bool });
    },
    translateQuestion(value) {
      console.log(value);
      return value;
    },
    translateOptions(options) {
      return options.map(option => ({
        value: {
          text: this.$t(option.value.text),
          showInput: option.value.showInput,
          points: option.value.points
        }
      }));
    },
    showInput(question) {
      if (question.input) {
        question.input.hidden = true;
        if (Array.isArray(question.value)) {
          question.value.forEach(value => {
            if (question.value.showInput === true) {
              question.input.hidden = false;
            }
          });
        } else {
          if (question.value.showInput === true) {
            question.input.hidden = false;
          }
        }
      }
    },
    submit() {
      this.$refs.submit.click();
      return this.$refs.form.checkValidity();
    },
    sendQuestionnaireForm() {
      this.$parent.$parent.loading = true;

      console.log(this.model);

      this.model.forEach(questionBlock => {
        questionBlock.questions.forEach(question => {
          question.text = this.$t(question.text);
        });
      });

      this.$store
        .dispatch("onboarding/saveInvestmentQuestionnaire", {
          contractType: this.contractType,
          questionnaireType: this.questionnaireType === 2 ? "short" : "long",
          questionnaireTypeId: this.questionnaireType,
          model: this.model
        })
        .then(() => {
          this.$parent.$parent.loading = false;
          this.$parent.$parent.nextStep();
        })
        .catch(() => {
          this.$parent.$parent.loading = false;
        });
    },
    setModel() {
      this.model = this.model.reduce((model, form) => {
        const initForm = {
          ...form,
          questions: form.questions.map(question => {
            if (!question?.multiple) {
              return {
                ...question,
                value: {
                  points: question.options.filter(o => {
                    return (
                      o.value.text ===
                      this.$store.state.onboarding.investmentQuestionnaire[
                        question.id - 1
                      ]["answer"]
                    );
                  })[0].value.points,
                  text: this.$store.state.onboarding.investmentQuestionnaire[
                    question.id - 1
                  ]["answer"]
                }
              };
            }

            const answers = this.$store.state.onboarding.investmentQuestionnaire[
              question.id - 1
            ]["answer"].split(",");

            const multipleQuestion = {
              ...question,
              value: []
            };

            answers.map(answer => {
              const showInput = !!question.options.filter(o => {
                return (
                  (o.value.text === answer.split("(")[0].trim() ||
                    o.value.text === answer) &&
                  o.value?.showInput
                );
              }).length;
              const splitAnswer = answer.split("(");

              const answerToPush = {
                points: question.options.filter(o => {
                  if (showInput) {
                    return o.value.text === splitAnswer[0].trim();
                  }
                  return o.value.text === answer.trim();
                })[0]?.value.points,
                text: showInput ? splitAnswer[0].trim() : answer.trim(),
                showInput: true
              };

              if (!showInput) {
                delete answerToPush.showInput;
              } else {
                multipleQuestion.input.value = splitAnswer[1]?.substring(
                  0,
                  splitAnswer[1].lastIndexOf(")")
                );
              }

              multipleQuestion.value.push(answerToPush);
            });

            return multipleQuestion;
          })
        };

        model.push(initForm);

        return model;
      }, []);
    }
  }
};
</script>

<style lang="scss">
.investment-questionnaire-form-wrapper {
  color: $text-color-default;

  .col-name {
    display: flex;
    justify-content: center;
    flex-direction: column;

    span {
      &:first-child {
        text-transform: uppercase;
      }

      &:last-child {
        font-size: 14px;
      }
    }
  }

  h2 {
    font-weight: bold;
    margin-bottom: 25px;
  }

  h3 {
    font-size: 16px;
  }

  .radio-list-wrapper {
    margin-bottom: 40px;
    padding-left: 25px;
    font-size: 15px;
  }

  input[type="radio"] {
    margin-right: 15px;
  }

  .radio-text-input {
    width: 90px;
    height: 25px;
    margin: 0 2px 5px 5px;
  }
}
</style>
